import classNames from 'classnames';
import { PropsWithChildren } from 'react';
import TYPOGRAPHY from '@/constants/typography';
import Paragraph from './Paragraph';

export type HeaderProps = {
  size?: 'sm' | 'base' | 'lg' | 'xl';
  className?: string;
  dataTestId?: string;
};

const Header = ({
  children,
  size = 'base',
  className,
  dataTestId,
  ...restProps
}: PropsWithChildren<HeaderProps>) => {
  return children ? (
    <Paragraph
      dataTestId={dataTestId}
      className={classNames('font-primary', TYPOGRAPHY.header[size] ?? '', className)}
      {...restProps}
    >
      {children}
    </Paragraph>
  ) : null;
};

export default Header;
